function getDeliveryEstimation(deliveryDays, defaultEstimation) {
  if (!deliveryDays.length) {
    return defaultEstimation;
  }
  let slowest = [0, 0];
  deliveryDays.forEach((value, index) => {
    const cleanValue = value.replace(/[^\d-]/g, "");
    const days = Number(cleanValue.split("-")[0]);
    if (days > slowest[0]) {
      slowest = [days, index];
    }
  });
  return deliveryDays[slowest[1]] ?? deliveryDays[0];
}
export {
  getDeliveryEstimation
};
//# sourceMappingURL=get-delivery-estimation.js.map
